import { get } from "../common/dataFetch";
import { WebControllers } from "../constants/webControllers";
import { WebActionNames } from "../constants/webActionNames";
import { Answer } from "../store/answer";

export const readMostRelevant = (question: string, searchMethod?: string, capturedSearchText?: string, emailaddress?: string) => get<Answer>(WebControllers.Answer, WebActionNames.ReadMostRelevant, { question, searchMethod, capturedSearchText, emailaddress });